import React, { useEffect, useState, useRef } from 'react';
import api from '../../api';
import RoomCard from '../card/RoomCard';
import Hotel from '../../assets/icone/card/alloggiColore.svg';
import CategoryCarousel from '../../components/utils/CategoryCarousel';
import { useTranslation } from 'react-i18next';

const RoomCarousel = () => {
  const [tickets, setTickets] = useState([]);
  const { t } = useTranslation();
  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return; // Se già eseguito, esce
    didFetch.current = true;

    const fetchRooms = async () => {
      try {
        const response = await api.get('/reservations/rooms/active');
        setTickets(response.data.activeItems);
      } catch (error) {
      }
    };

    fetchRooms();
  }, []);

  const renderRoomCard = (ticket) => (
    <RoomCard ticket={ticket} user={ticket.user_id} />
  );

  return (
    <CategoryCarousel
      items={tickets}
      categoryIcon={Hotel}
      categoryTitle={t('travel.RoomReservation')}
      renderCard={renderRoomCard}
      category="rooms"
    />
  );
};

export default RoomCarousel;
